module.exports = __webpack_public_path__ + "img/Logo-KPI-BSB-Final.4818b0af.png";